// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe-container[data-v-e4af88c4]{position:absolute;top:0;left:0;display:flex;height:100%;width:100%}iframe[data-v-e4af88c4]{height:100%;overflow-y:scroll}", ""]);
// Exports
module.exports = exports;
